var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.447 12.946v-7.8H1.892C.846 5.146 0 5.962 0 6.965v16.123c0 .811 1.021 1.214 1.617.643l3.91-3.749H16.66c1.046 0 1.892-.81 1.892-1.814V14.76H7.344c-1.046 0-1.897-.811-1.897-1.814Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.108 0H7.344C6.298 0 5.452.811 5.452 1.814v3.332H16.66c1.046 0 1.892.81 1.892 1.814v7.795h3.555c1.046 0 1.892-.811 1.892-1.814V1.814C24 .811 23.154 0 22.108 0Z",
    fill: "#5BB974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.66 5.146H5.448v7.795c0 1.003.846 1.814 1.892 1.814h11.21v-7.79c.004-1.003-.842-1.82-1.888-1.82Z",
    fill: "#00832D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGoogle;